// extracted by mini-css-extract-plugin
module.exports = {"slider":"Toggle_slider__uvEH_","round":"Toggle_round__ry04L"};